<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
const t = useI18n().t;
</script>

<template>
    <div class="marquee gap no-top">
        <div class="marquee-box-one">
            <div class="marquee-content-one">
                <a href="#">
                    <h2>{{ t('Construction') }}</h2>
                </a>
                <a href="#">
                    <h2>{{ t('Interior Design') }}</h2>
                </a>
                <a href="#">
                    <h2>{{ t('Modern Structures') }} </h2>
                </a>
                <a href="#">
                    <h2>{{ t('Ideas') }}</h2>
                </a>
            </div>
            <div class="marquee-content-one">
                <a href="#">
                    <h2>{{ t('Urban planning') }}</h2>
                </a>
                <a href="#">
                    <h2>{{ t('Land development') }}</h2>
                </a>
                <a href="#">
                    <h2>{{ t('Modern Structures') }} </h2>
                </a>
                <a href="#">
                    <h2>{{ t('Ideas') }}</h2>
                </a>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.marquee {
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    padding: 0 !important;

    h2{
        color: black !important;
    }
}
</style>